module.exports = "<svg viewBox=\"0 0 14 5\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2.333 3.667h9.334a1.333 1.333 0 0 0 0-2.667H2.333a1.333 1.333 0 0 0 0 2.667z\" stroke=\"#394F5A\" stroke-width=\"0.55\" fill=\"#EB5735\" fill-rule=\"nonzero\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/svg/minus.svg
// module id = 3iND
// module chunks = 89